import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import { installBugRecorder } from './bugs/recorder.js'
import { releaseBootWhenDrawn } from './components/Loader.js'
// Eco's frog, as a custom element. Here rather than beside EcoAvatar so a
// jsdom test never defines it. Decision 116.
import './components/eco/eco-avatar.js'
import './styles.css'

// Before anything draws, so a bug report carries what went wrong while the
// app was starting too. Decision 117.
installBugRecorder()

const container = document.getElementById('root')
if (!container) throw new Error('No #root element')

releaseBootWhenDrawn(container)

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
